export default "__VITE_ASSET__CLoAJ3gB__"